import advancedSearch from './modules/advancedSearch';
import user from './modules/user';
import grantItems from './modules/grantItems';
import news from './modules/news';
import auth from './modules/auth';
import tags from './modules/tags';
import newsSearch from './modules/newsSearch';
import advancedFilters from './modules/advancedFilters';
import organisations from './modules/organisations';
import { createStore } from 'vuex'; //, createLogger
import homePageItems from './modules/homePageItems';
import importItems from './modules/importItems';
import fileRecords from './modules/fileRecords';
import fomoRecordsSearch from './modules/fomoRecordsSearch';
import fomoStatisticsSearch from './modules/fomoStatisticsSearch';
import statistics from './modules/statistics';

export default createStore({
    modules: {
        advancedSearch: advancedSearch,
        user: user,
        grantItems: grantItems,
        news: news,
        auth: auth,
        newsSearch: newsSearch,
        tags: tags,
        advancedFilters: advancedFilters,
        organisations: organisations,
        homePageItems: homePageItems,
        importItems: importItems,
        fileRecords: fileRecords,
        fomoRecordsSearch: fomoRecordsSearch,
        statistics: statistics,
        fomoStatisticsSearch: fomoStatisticsSearch
    },
    strict: false,
    plugins: []
});
